<template>
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;">
    <v-flex xs6 class="inline-block px-4">
      <label>{{$t('Admin.Glider.Form.Key')}}:</label>&nbsp;<span>{{glider.GLI_KEY}}</span><br/>
      <label>{{$t('Admin.Glider.Form.Surname')}}:</label>&nbsp;<span>{{glider.GLI_LIBELLE}}</span><br/>
      <label>{{$t('Admin.Glider.Form.Model')}}:</label>&nbsp;<span>{{glider.GLI_FABRICANT}}</span><br/>
      <label>{{$t('Admin.Glider.Form.ManufacturingDate')}}:</label>&nbsp;<span>{{glider.GLI_DATFAB|formatDate}}</span><br/>
      <label>{{$t('Admin.Glider.Form.SerialNumber')}}:</label>&nbsp;<span>{{glider.GLI_NSERIE}}</span><br/>
      <label>{{$t('Admin.Glider.Form.Manufacturer')}}:</label>&nbsp;<span>Alseamar</span><br/>
      <label>{{$t('Admin.Glider.Form.MaxDepth')}}:</label>&nbsp;<span>{{glider.GLI_PMAX}}</span><br/>
      <label>{{$t('Admin.Glider.Form.Status')}}:</label>&nbsp;<span></span>
      <div class="my-4" style="display:block">
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content class="my-0">
            <v-layout style="height:40px;" slot="header" align-center>
              <span class="subheading">Documents</span>
            </v-layout>
            <v-card>
              <v-list>
                <v-list-tile>
                  <v-btn icon @click.prevent>
                    <v-icon @click.prevent>mdi-file-download</v-icon>
                  </v-btn>
                  <v-list-tile-title>GPCTD - SN 0456</v-list-tile-title>
                </v-list-tile>
                <v-list-tile>
                  <v-btn icon @click.prevent>
                    <v-icon @click.prevent>mdi-file-download</v-icon>
                  </v-btn>
                  <v-list-tile-title>METS - SN 0874</v-list-tile-title> 
                </v-list-tile>
                <v-list-tile>
                  <v-btn icon @click.prevent>
                    <v-icon @click.prevent>mdi-file-download</v-icon>
                  </v-btn>
                  <v-list-tile-title>Payload 3 - SN 0874</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </v-flex>
    <v-flex xs6 class="px-4" order-xs2>       
      <v-expansion-panel expand :value="[true]">     
        <v-expansion-panel-content class="my-0">
          <v-layout style="height:40px;" slot="header" align-center>
            <span class="subheading">Options</span>
          </v-layout>
          <v-card>
            <v-list>
              <v-list-tile>
                <v-btn icon @click.prevent>
                  <v-icon @click.prevent>mdi-information</v-icon>
                </v-btn>
                <v-list-tile-title>Argos - SN 0874</v-list-tile-title>             
              </v-list-tile>
              <v-list-tile>
                <v-btn icon @click.prevent>
                  <v-icon @click.prevent>mdi-information</v-icon>
                </v-btn>
                <v-list-tile-title>Altimeter - SN 0874</v-list-tile-title>             
              </v-list-tile>
            </v-list>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <br/>
      <v-expansion-panel expand :value="[true]">     
        <v-expansion-panel-content class="my-0">
          <v-layout style="height:40px;" slot="header" align-center>
            <span class="subheading">Payload</span>
          </v-layout>
          <v-card>
            <v-list>
              <v-list-tile>   
                <v-btn icon @click.prevent>
                  <v-icon @click.prevent>mdi-information</v-icon>
                </v-btn>         
                <v-list-tile-title>GPCTD - SN 0456</v-list-tile-title>              
              </v-list-tile>
              <v-list-tile>  
                <v-btn icon @click.prevent>
                  <v-icon @click.prevent>mdi-information</v-icon>
                </v-btn>            
                <v-list-tile-title>METS - SN 0874</v-list-tile-title>              
              </v-list-tile>
              <v-list-tile>      
                <v-btn icon @click.prevent>
                  <v-icon @click.prevent>mdi-information</v-icon>
                </v-btn>      
                <v-list-tile-title>Payload 3 - SN 0874</v-list-tile-title>              
              </v-list-tile>
            </v-list>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
  </v-layout>        
</template>

<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import Fiche from '@/components/admin/Fiche.vue'

  @Component({
    name: 'FicheGlider'
  })
  export default class FicheGlider extends Vue {  
    
    get glider() {
      return this.$store.myGetters.originalAdmGlider
    }
    
  }
</script>